<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
  export default {
    name: 'JoinGroupOverlay',
    props: {
      group: Object,
      isOpen: Boolean,
      pending: Object,
    },
    computed: {
      opened: {
        set() {
          this.$emit('onCloseOverlay')
        },
        get() {
          return this.isOpen
        },
      },
    },
    methods: {
      joinGroup() {
        this.$emit('onJoinGroup', this.group.id)
      },
      requestApproval() {
        this.$emit('onRequestApproval', this.group.id)
      },
    },
  }
</script>
